<template>
    <iframe :src="url"></iframe>
</template>
<script>

export default {
  props: ["url"],
  name: "igframe",
  components: { },
  data: function() {
    return { }
  },
  mounted: async function() { },
  computed: { },
  methods: { }
};
</script>
<style scoped>
iframe {
    width: 100vw;
    height: calc(100vh - 130px);
}
</style>